<template>
  <ApplicationRoot id="applicationRoot"/>
</template>

<script>
import ApplicationRoot from './components/ApplicationRoot.vue'
export default {
  name: 'app',
  components: {ApplicationRoot},
  mounted() {
    this.$eventHandlerApi.callStartEventHandler()
  }
}
</script>
<style lang="scss">
  @import "../node_modules/fontsource-roboto/100.css";
  @import "../node_modules/fontsource-roboto/300.css";
  @import "../node_modules/fontsource-roboto/400.css";
  @import "../node_modules/fontsource-roboto/500.css";
  @import "../node_modules/fontsource-roboto/700.css";
  @import "../node_modules/fontsource-roboto/900.css";

  @import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
  @import "../node_modules/ag-grid-community/dist/styles/ag-theme-material.css";
</style>